import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/home';

export default function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-background-50/80 backdrop-blur-md border-b border-background-200/50">
      <nav className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16" aria-label="主导航">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
          <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
            <i className="ri-book-open-line text-background-50 text-lg"></i>
          </span>
          <span className="font-heading text-xl text-foreground-950">韩漫漫画网</span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          <Link
            to="/"
            className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${isActive('/') ? 'text-primary-600' : 'text-foreground-700 hover:text-primary-500'}`}
          >
            首页
          </Link>
          <div className="relative group">
            <button className="text-sm font-medium text-foreground-700 hover:text-primary-500 whitespace-nowrap cursor-pointer transition-colors flex items-center gap-1">
              分类 <i className="ri-arrow-down-s-line text-xs"></i>
            </button>
            <div className="absolute top-full left-1/2 -translate-x-1/2 pt-2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
              <div className="bg-background-50 rounded-lg border border-background-200/70 py-2 px-1 shadow-sm min-w-[180px]">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-700 hover:text-primary-600 hover:bg-background-100 rounded-md cursor-pointer whitespace-nowrap transition-colors"
                  >
                    <span className="w-5 h-5 flex items-center justify-center">
                      <i className={`${cat.icon} text-xs`}></i>
                    </span>
                    {cat.name}
                    <span className="text-xs text-foreground-400 ml-auto">{cat.count}</span>
                  </Link>
                ))}
              </div>
            </div>
          </div>
          <Link
            to="/category/romance"
            className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${isActive('/category/romance') ? 'text-primary-600' : 'text-foreground-700 hover:text-primary-500'}`}
          >
            排行榜
          </Link>
          <Link
            to="/about"
            className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${isActive('/about') ? 'text-primary-600' : 'text-foreground-700 hover:text-primary-500'}`}
          >
            关于我们
          </Link>
        </div>

        <div className="hidden md:flex items-center gap-3">
          <button className="w-9 h-9 flex items-center justify-center rounded-full hover:bg-background-100 cursor-pointer transition-colors" aria-label="搜索">
            <i className="ri-search-line text-foreground-600 text-lg"></i>
          </button>
          <Link
            to="/category/romance"
            className="px-5 py-2 bg-primary-500 text-background-50 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
          >
            开始阅读
          </Link>
        </div>

        <button
          className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg hover:bg-background-100 cursor-pointer transition-colors"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="菜单"
        >
          <i className={`text-xl text-foreground-700 ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/50 px-4 py-4">
          <div className="flex flex-col gap-2">
            <Link to="/" className="py-3 px-4 text-sm font-medium text-foreground-700 hover:bg-background-100 rounded-lg cursor-pointer" onClick={() => setMobileMenuOpen(false)}>首页</Link>
            <div className="py-3 px-4 text-sm font-medium text-foreground-500">分类</div>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="py-2.5 px-8 text-sm text-foreground-600 hover:bg-background-100 rounded-lg cursor-pointer flex items-center gap-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className={`${cat.icon} text-xs`}></i>
                </span>
                {cat.name}
              </Link>
            ))}
            <Link to="/about" className="py-3 px-4 text-sm font-medium text-foreground-700 hover:bg-background-100 rounded-lg cursor-pointer" onClick={() => setMobileMenuOpen(false)}>关于我们</Link>
            <Link
              to="/category/romance"
              className="mt-2 py-3 px-4 text-sm font-medium text-background-50 bg-primary-500 rounded-full text-center cursor-pointer"
              onClick={() => setMobileMenuOpen(false)}
            >
              开始阅读
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}